import styled from 'styled-components';
import Link from 'next/link';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

export const LandingCardWrapper = styled.div`
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 167px;
  padding: 15px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 15px 20px;
  }
`;

export const NameLocationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  font-size: 12px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    flex-direction: row;
  }
`;

export const Name = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => `${theme.palette.eclipse}`};
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: 18px;
  }
`;

export const InfoLink = styled(Link)`
  color: inherit;
`;

export const Wrapper = styled.div.attrs((props) => ({
  className: props.className,
}))<{ isDurationIncluded: boolean }>`
  .image-wrapper {
    position: relative;
    width: 100%;
  }
  &.mobile-card-container {
    height: ${(props) => (props.isDurationIncluded ? '320px' : '334px')};
    .image-wrapper {
      height: 50%;
    }
  }
  &.big-card-container {
    height: ${(props) => (props.isDurationIncluded ? '746px' : '700px')};
    .image-wrapper {
      height: 560px;
    }
  }
  &.small-card-container {
    height: ${(props) => (props.isDurationIncluded ? '362px' : '339px')};
    .image-wrapper {
      height: 176px;
    }
  }
`;

export const MainProps = styled.div`
  font-size: 12px;
  letter-spacing: 0.43px;
  color: ${({ theme }) => `${theme.palette.darkGrey}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: 14px;
  }

  @media (max-width: ${LANDING_BREAKPOINT}) {
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
  }
`;

export const EverythingIncluded = styled.div`
  white-space: nowrap;
  padding-top: 5px;
  font-size: 12px;
  letter-spacing: 0.43px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: 14px;
    letter-spacing: 0.5;
  }
`;

export const Location = styled.div`
  font-weight: 600;
`;

export const DurationContainer = styled.div`
  display: flex;
  padding-bottom: 3px;
  align-items: center;
`;

export const DurationText = styled.span`
  color: ${({ theme }) => `${theme.palette.brownishGrey}`};
  font-size: 14px;
  font-weight: 600;
  padding-left: 5px;
`;
export const StyledButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 8px 10px;
  height: 43px;
  border-radius: 2px;
  background-color: ${({ theme }) => `${theme.palette.purple500}`};
  border-color: transparent;
  color: ${({ theme }) => `${theme.palette.bluishPurple}`};
  cursor: pointer;
  border-radius: 8px;
`;
export const CustomIconWrapper = styled.div`
  margin-top: 3px;
`;

export const Separator = styled.div`
  margin-top: 10px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
